import { render, staticRenderFns } from "./PatientOverviewSmoking.vue?vue&type=template&id=32c08f67&"
import script from "./PatientOverviewSmoking.vue?vue&type=script&lang=js&"
export * from "./PatientOverviewSmoking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports